import { render, staticRenderFns } from "./ScreeningStatusHistory.vue?vue&type=template&id=56485178&scoped=true&"
import script from "./ScreeningStatusHistory.vue?vue&type=script&lang=js&"
export * from "./ScreeningStatusHistory.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningStatusHistory.vue?vue&type=style&index=0&id=56485178&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56485178",
  null
  
)

export default component.exports